(function (angular, app) {
   "use strict";

   app.modules.invitation = {
      name: "app.Invitations",
      controllers: {
      }
      , directives : {
      }
      , services : {
         invite : "gg_InvitationsFactory"
      }
      , features : {
      }
      , routes: {
         invited: {
            path: "/invite"
            , controller: "ggInvitedController"
            , controllerAs: "ggInvitedCtrl"
            , templateUrl: "app/invitation/controllers/invited.html"
            , features: {
               showHeading: false
            }
            , accessControl: {
                roles: ["ANONYMOUS", "AUTHENTICATED"]
                , roleCheckType: 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
      }

   };
    
   angular.module(app.modules.invitation.name, []);

}(angular, app));
